import PostHog from "posthog-react-native";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";

const apiKey = process.env.EXPO_PUBLIC_POSTHOG_PROJECT_TOKEN;
const host = process.env.EXPO_PUBLIC_POSTHOG_HOST;
const isPostHogConfigured =
  !!apiKey && apiKey !== "phc_your_project_token_here";

function createClient(): PostHog | undefined {
  if (typeof window === "undefined" || !isPostHogConfigured) {
    return undefined;
  }

  const posthog = new PostHog(apiKey!, {
    host,
    captureNativeAppLifecycleEvents: Platform.OS !== "web",
    flushAt: 20,
    flushInterval: 10000,
    maxBatchSize: 100,
    maxQueueSize: 1000,
    preloadFeatureFlags: true,
    requestTimeout: 10000,
    fetchRetryCount: 3,
    fetchRetryDelay: 3000,
    // expo-file-system@55 deprecated readAsStringAsync/writeAsStringAsync throw errors
    // without try-catch in PostHog's setItem, causing unhandled rejections that crash
    // production Hermes builds. AsyncStorage works on all platforms.
    customStorage: AsyncStorage,
  });

  try {
    if (__DEV__) {
      posthog.debug(true);
    } else {
      posthog.debug(false);
    }

    return posthog;
  } catch {
    return undefined;
  }
}

export const posthog = createClient();
